module.exports = __webpack_public_path__ + "static/media/icon_dash.bf8e455e.svg";